import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Definitionscertificate_interface } from 'src/app/Interface/Definitionscertificate_interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DefinitionscertificateService {

  constructor(private http:HttpClient) { }


  GetRecord(Token:String):Observable<Array<Definitionscertificate_interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Definitionscertificate?token="+Token).pipe(
      map(data=>{
        return data as Array<Definitionscertificate_interface>
      })
    )
  }

  GetSingle(Token:String,id:Number):Observable<Definitionscertificate_interface>{
    return this.http.get(environment.BaseUrl + "Daro/Definitionscertificate/GetSingle?token="+Token+"&id="+id).pipe(
      map(data=>{
        return data as Definitionscertificate_interface
      })
    )
  }

  AddDefinitionscertificate(model: Definitionscertificate_interface,Token:String):Observable<Definitionscertificate_interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      quantity_id:model.quantity_id,
      CALIBRATIONMETHOD:model.cALIBRATIONMETHOD,
      UNCERTAINTY:model.uNCERTAINTY,
      TRACEABILITY:model.tRACEABILITY,
      DecisionRule:model.decisionRule,
      Code:model.code,
      del:false,
      username:Token
    }


      return this.http.post(environment.BaseUrl + "Daro/Definitionscertificate/Add",body,{headers}).pipe(
        map(data=>{
          return data as Definitionscertificate_interface
        })
      )

  }

  DeleteDefinitionscertificate(id:number,Token:String):Observable<Definitionscertificate_interface>{

      return this.http.get(environment.BaseUrl + "Daro/Definitionscertificate/Delete?id="+id+"&token="+Token).pipe(
        map(data=>{
          return data as Definitionscertificate_interface
        })
      )

  }

  }

